import DeliveryService from "../DeliveryService"


const Driver = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/console/drivers'
        if (r != undefined) {
            url = '/console/enterprises?' + r
        }
        return DeliveryService.get(url)
    },
}
export default Driver